<template>
  <div class="style-container style-container-shadow mt-4">
    <div class="d-flex flex-column">
      <div class="d-flex flex-row">
        <!-- Image -->
        <div class="w-25">
          <smart-image
            :imageURL="purchaseItem?.product?.image"
            class="style-img"
          />
        </div>
        <!-- Content -->
        <div class="w-75 text-start p-3 d-flex flex-column style-content">
          <span class="scss-bold" v-if="purchaseItem.product.name">{{
            purchaseItem.product.name
          }}</span>
          <span class="scss-overflow-text-style" v-if="purchaseItem.date"
            >Purchased: {{ purchaseItem.date }}
          </span>
          <span
            class="scss-overflow-text-style"
            v-if="purchaseItem.lastConsumed"
            >Last Consumed: {{ purchaseItem.lastConsumed }}
          </span>
          <span
            class="scss-overflow-text-style"
            v-if="purchaseItem.redeemedDate"
            >Redeemed Date: {{ purchaseItem.redeemedDate }}
          </span>
          <span class="scss-overflow-text-style" v-if="purchaseItem.expiryDate"
            >Expiry: {{ formatExpiryDate(purchaseItem.expiryDate) }}
          </span>
          <span
            class="scss-overflow-text-style"
            v-if="purchaseItem.processingTime"
            >Duration: {{ purchaseItem.processingTime }} Mins</span
          >
          <span
            class="scss-overflow-text-style style-pending-unit scss-error-text-color"
            v-if="purchaseItem.pendingUnit"
            >Upcoming Booking: {{ purchaseItem.pendingUnit }}</span
          >
        </div>
      </div>
    </div>
    <!-- Remaining Sessions & Action -->
    <div
      class="style-action-container d-flex flex-row"
      v-if="disableButton === false"
    >
      <div class="w-50 d-flex align-items-center">
        <div
          class="w-50 scss-text-ligh-blue style-remaining-session text-center"
        >
          {{ purchaseItem.unitRemain }}
        </div>
        <div class="w-50 text-start style-remaining-session-title">
          <span class="scss-small-font">sessions remaining</span>
        </div>
      </div>
      <div
        class="flex-grow-1"
        :class="
          (purchaseItem &&
            purchaseItem.pendingUnit >= purchaseItem.unitRemain) ||
          purchaseItem.unitRemain === 0
            ? 'style-disable-button'
            : 'style-book-button'
        "
        @click="goToAppointment(purchaseItem)"
      >
        Book
      </div>
    </div>
    <!-- Quantity Sessions & Action -->
    <div class="style-action-container d-flex flex-row" v-else>
      <div class="w-50 d-flex align-items-center">
        <div
          class="w-50 scss-text-ligh-blue style-remaining-session text-center"
        >
          {{ purchaseItem.unitRemain }}
        </div>
        <div class="w-50 text-start style-remaining-session-title">
          <span class="scss-small-font">Qty(s)</span>
        </div>
      </div>
      <div class="flex-grow-1 style-disable-button">Redeem in shop</div>
    </div>
  </div>
</template>

<script>
import SmartImage from "@/components/SmartImage.vue";

export default {
  name: "PurchaseItem",
  components: { SmartImage },
  props: {
    purchaseItem: Object,
    disableButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToAppointment(purchaseItem) {
      if (
        purchaseItem.pendingUnit < purchaseItem.unitRemain &&
        purchaseItem.unitRemain !== 0
      ) {
        sessionStorage.setItem(
          "serviceDetails",
          JSON.stringify({
            description: this.purchaseItem.product.description,
            id: this.purchaseItem.product.id,
            imageURL: this.purchaseItem.product.image,
            name: this.purchaseItem.product.name,
            type: this.purchaseItem.type,
            processingTime: this.purchaseItem.processingTime,
            formatProcessingTime: this.purchaseItem.formatProcessingTime,
            price:  this.purchaseItem.price,
            promotion: false, // consume prepaid purchase item is not a promotion item, but it maybe a promotion item at purchase ticket
            promotionId: 0, // consume prepaid purchase item is not a promotion item, but it maybe a promotion item at purchase ticket
            promotionPrice: this.purchaseItem.product.service.promotionPrice, // follow product profile, it wont affected due to explicitly set `promotion` to false and `promotionId` to 0
            promotionStartDate: this.purchaseItem.product.service.startDate, // follow product profile, it wont affected due to explicitly set `promotion` to false and `promotionId` to 0, and backend not able to set "0000-00-00", it return an old date
            promotionEndDate: this.purchaseItem.product.service.endDate, // follow product profile, it wont affected due to explicitly set `promotion` to false and `promotionId` to 0, and backend not able to set "0000-00-00", it return an old date
            originalPrice: "", // consume prepaid purchase item can ignore this because it's consume prepaid not purchase
            salePrice: this.purchaseItem.price, // display prepaid purchase purchase price(it purchase ticket price) instead of product profile price
            prepaidItemId: this.purchaseItem.id,
            sectionName: this.purchaseItem.product.productSection?.name,
            categoryName: this.purchaseItem.product.productCategory?.name,
          })
        );
        this.$router.push("/make-appointment");
      }
    },
    formatExpiryDate(date) {
      if (date === "1899-11-30") {
        return "-";
      }
      return date;
    },
  },
};
</script>

<style scoped lang="scss">
/* New Style */
.style-container {
  border: 1px solid #dadada;
  border-right: none;
  border-bottom: none;
  width: 90%;
  margin: 0 auto 0 auto;
  height: fit-content;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.style-container-shadow {
  box-shadow: 1px 2px $border-light-grey;
}

.style-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  min-height: 150px;
}

.style-content {
  font-size: 12px;
  line-height: 24px;
}

.style-action-container {
  height: 60px;
  border-top: 1px solid $border-light-grey;
}

.style-book-button {
  background-color: $text-blue;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.style-book-button:hover {
  opacity: 0.8;
}

.style-book-button:hover {
  opacity: 0.8;
}

.style-book-button:active {
  box-shadow: 3px 2px 22px 1px rgba(134, 134, 134, 0.24);
  transform: scale(1.01, 1.01);
}

.style-disable-button {
  background-color: $text-light-color;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.style-description {
  max-height: 75px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.style-remaining-session {
  font-size: 42px;
  // padding-left: 35%;
}

.style-remaining-session-title {
  max-width: 20px;
  line-height: 15px;
}
</style>
